import { Action } from '@/_core/fluxstore/types';
import { uuid } from '@/_core/utils/uuid';
import { StorymapState, Subtask, Task } from '../../types';
import { getActiveCard, getCardById, getDefaultStatus } from '../../use';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class AddNewSubtask extends Action<StorymapState> {
    public static ACTION_TYPE = 'AddNewSubtask';

    public _cardId: string = null;
    public constructor(
        public parentTaskId: string,
        public releaseId: string,
        public order: number,
        public willBeSavedImmediately: boolean = false
    ) {
        super(AddNewSubtask.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: AddNewSubtask): Promise<boolean> => {
    action._cardId = await uuid.create();
    return true;
};

const reducer = (state: StorymapState, action: AddNewSubtask): void => {
    const activeCard = getActiveCard();

    const parentTask = getCardById(action.parentTaskId) as Task;

    state.subtasks
        .filter((x) => x.taskId == parentTask.id && x.releaseId == action.releaseId && x.order >= action.order)
        .forEach((x) => x.order++);

    const subtask: Subtask = {
        id: action._cardId,
        activityId: parentTask.activityId,
        taskId: parentTask.id,
        releaseId: action.releaseId,
        title: '',
        description: '',
        color: state.subtaskColor,
        status: getDefaultStatus().key,
        order: action.order,
        assigneeUserId: null,
        key: null,

        isNew: action.willBeSavedImmediately ? false : true,
        isActive: true,
        activeUsers: [],
        isMultiselected: false,
        isTitleEditing: false,
        isCopied: false,
        isCut: false,
        personaIds: [],
        annotationIds: [],
        basicPrioValue: null,
        businessValue: null,
        effort: null,
        kanoPrioValue: null,
        moscowPrioValue: null,
        releaseViewOrder: null,

        hasDescription: false,
        hasAttachment: false,
        hasComment: false,
        hasFeedback: false,
        isSaving: action.willBeSavedImmediately ? true : false,

        isLinkedToIntegrationTool: false,
        linkedUrl: '',
        linkedItemKey: '',
        linkedItemTypeId: null,
        linkedItemTypeName: null,
        estimation: null,

        createdAt: new Date(),
        createdByUserId: initAppData.currentUser.currentUserShortId,
        lastUpdatedAt: null,
        lastUpdatedByUserId: null,
    };

    state.subtasks.push(subtask);

    // Track newly created card for visibility in hide-unfiltered mode
    if (state.filterState.hideUnfiltered) {
        state.filterState.newlyCreatedCardIds.push(subtask.id);
    }

    if (activeCard) {
        activeCard.isActive = false;
    }

    return;
};

//@ts-ignore
registerMiddleware(AddNewSubtask.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(AddNewSubtask.ACTION_TYPE, reducer);
